import { ACTION_LOG_TYPE } from "Common/dictionaries/actionLogType";
import createReducer from "Common/reducerUtils/createReducer";
import { NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: {
        actionLogEventTypeDictionary: undefined,
        actionLogUsers: undefined,
        actionLogProjects: undefined,
        actionLogType: ACTION_LOG_TYPE.SYSTEM_ACCESS
    }
};
export default createReducer(initialState, {
    [actionTypes.SET_ACTION_LOG_TYPE]: (state, { actionLogType }) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            actionLogType
        }
    }),
    [actionTypes.GET_ACTION_LOG_EVENT_TYPE_DICTIONARY_COMPLETED]: (state, { payload }) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            actionLogEventTypeDictionary: payload
        }
    }),
    [actionTypes.GET_ACTION_LOG_USERS_COMPLETED]: (state, { payload }) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            actionLogUsers: payload
        }
    }),
    [actionTypes.GET_ACTION_LOG_PROJECTS_COMPLETED]: (state, { payload }) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            actionLogProjects: payload
        }
    })
});
